import {Controller} from "stimulus"

export default class extends Controller {

    static targets = [
        "toggler",
        "target"
    ]

    initialize() {

        this.togglerTarget.addEventListener("click", () => {
            this.targetTarget.classList.toggle("is-active")
        })

    }


}